import OadpEntityTable from './oadp-entity-table';
export default OadpEntityTable;
